import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { ScientificObjectRef } from './ScientificObjectRef';
import type { ScientificObjectSummary } from './ScientificObjectSummary';
import { scientificObjectTypePath } from './ScientificObjectType';

export async function getScientificObjectSummary(reference: ScientificObjectRef): Promise<ScientificObjectSummary> {
  return apiRequest<ScientificObjectSummary>(
    `/scientific-objects/${scientificObjectTypePath(reference.type)}/${encodeURIComponent(reference.id)}`,
    'scientific object'
  );
}
